$(document).ready(function () {
    var $window = $(window);
    var $body = $('body');
    var $formCollection = $('.form-group textarea, .form-group input');
    function modalOpen() {
        $body.addClass('modal-open');
    }

    function modalClose() {
        $body.removeClass('modal-open');
    }

    function searchModal() {
        $('#search-input').bind('keyup', function (e) {
            var $this = $(e.currentTarget);
            var $searchBtn = $('.modal__btn');

            if ($this.val() !== '') {
                $searchBtn.addClass('modal__btn--show');
            } else {
                $searchBtn.removeClass('modal__btn--show');
            }
        });
        $('.close').on('click', function (e) {
            var $this = $(e.currentTarget);
            $this.closest('.modal').fadeOut();
            modalClose();
        });
        $('.searchBtn-modal').on('click', function (event) {
            // event.preventDefault();
            $('#search-modal').fadeIn();
            $('#search-input').focus();
            modalOpen();
        });
        $(document).mouseup(function (e) {
            var div = $('.modal__wrapper, .modal__auth');
            if (!div.is(e.target) && div.has(e.target).length === 0) {
                $('.modal').fadeOut();
                modalClose();
            }
        });
    }
    function textareaFocus() {
        $formCollection.focus(function (e) {
            var $this = $(e.currentTarget);
            var parent = $this.parent();
            var label = parent.children('label'); // let labelIcon = label.children('svg, .comment__form-name');

            parent.addClass('focused');
            label.fadeOut();

            if ($this.val() !== '') {
                label.fadeOut();
            }
        }).blur(function (e) {
            var $this = $(e.currentTarget);
            var parent = $this.parent();
            var label = parent.children('label'); // let labelIcon = label.children('svg,.comment__form-name');

            if ($this.val() === '') {
                parent.removeClass('focused');
                label.fadeIn('fast');
                $this.closest('form').removeClass('comment__form--show');
            }

            if ($this.val() !== '') {
                parent.removeClass('focused');
                label.fadeOut();
            }
        }).bind('keyup', function (e) {
            var $this = $(e.currentTarget);
            var parent = $this.parent();
            var clrBtn = parent.children('.clear-input');

            if ($this.val() !== '') {
                $this.closest('form').addClass('comment__form--show');
                clrBtn.fadeIn();
            } else {
                $this.closest('form').removeClass('comment__form--show');
                clrBtn.fadeOut();
            }
        });
        $('.clear-input').on('click', function (e) {
            var $this = $(e.currentTarget);
            var parent = $this.closest('.form-group');
            var label = parent.children('label');
            var input = parent.children('input');
            input.val('');
            label.fadeIn();
            $this.fadeOut();
            $('.modal__btn').removeClass('modal__btn--show');
        });
    }

    searchModal();
    textareaFocus()

    /**
     * Left menu ichida Daryo indo yani qo'shimcha sahifalar uchun toggle bar
     * */
    $('.mobile-menu__daryo-info li .chevron').on('click', function() {
        $(this).closest('li').find('ul')
            .first()
            .parent()
            .toggleClass('active item-active');

        return false;
    });


    /**
     * Login modal authorization-screen
     * */

    $('body').delegate('.login-modal-btn', 'click', function (event) {
        event.preventDefault()
        $('body').addClass('modal-open');
        // $('.login-modal').css('display', 'block');
        $('#auth-modal').addClass('is-open');
        $('#auth-modal').attr('aria-hidden',false);
        clearLoginAndRegisterModal();
    });
    $('body').delegate('.register-link', 'click',function (e){
        $('.auth-modal-login').css('display','none')
        $('.auth-modal-register').css('display','block')
        $('#loginform-email').val('');
        $('#loginform-password').val('');
        clearLoginAndRegisterModal();
    });
    $('body').delegate('.login-link', 'click',function (e){
        $('.auth-modal-login').css('display','block')
        $('.auth-modal-register').css('display','none')
        $('#registrationform-last_name').val('');
        $('#registrationform-email').val('');
        clearLoginAndRegisterModal();
    });
    $('body').delegate('.close-btn', 'click',function (e){
        e.preventDefault()
        $('#auth-modal').removeClass('is-open');
        $('#auth-modal').attr('aria-hidden',true);
        $('body').removeClass('modal-open');
        $('#loginform-email').val('');
        $('#loginform-password').val('');
        $('#registrationform-last_name').val('');
        $('#registrationform-email').val('');
        clearLoginAndRegisterModal();
    });
});
function clearLoginAndRegisterModal(){
    $('.input-group input').removeClass('is-invalid');
    $('.input-group .invalid-feedback').text('');
    $('.input-group.info .invalid-feedback').removeClass('is-message');
}
$(document).ready(function() {
    $('body').delegate('#login-form', 'submit', function(event) {
        event.preventDefault();
        var form = $(this);

        clearLoginAndRegisterModal();
        $.ajax({
            url: form.attr('action'),
            type: 'post',
            data: form.serialize(),
            success: function(response) {
                console.log("response",response);
                if (response.status) {
                    $('.login-modal').css('display', 'none');
                    $('body').removeClass('modal-open');
                    window.location.reload();
                } else {
                    if(!response.status){
                        formValidation(response.errors);
                    }
                }
            }
        });
        return false; // Prevent default form submission
    });

    $('body').delegate('#register-form', 'submit', function(event) {
        event.preventDefault();
        var form = $(this);
        clearLoginAndRegisterModal();
        $.ajax({
            url: form.attr('action'),
            type: 'post',
            data: form.serialize(),
            success: function(response) {
                console.log('response', response)

                if (response.status) {
                    $('.login-modal').css('display', 'none');
                    $('body').removeClass('modal-open');
                    $('.auth-modal-login').css('display','block')
                    $('.auth-modal-register').css('display','none')
                    $('#loginform-email').val(response.email??'');
                    $('#login-form').find('.input-group.info').find('.invalid-feedback').addClass('is-message').text(response.message??'');
                } else {
                    if(!response.status){
                        formValidation(response.errors);
                    }
                }
            }
        });
        return false; // Prevent default form submission
    });
    function formValidation(errors){
        clearLoginAndRegisterModal();
        errors.map((error, index) => {
            $('.field-' + error.key).find('.invalid-feedback').text(error.message).show();
            $('#' + error.key).addClass('is-invalid');
        });
    }
});

// So'ngi yangiliklarni scrolli infinity qilish uchun js
function latestNews(){

    const newsContainer = document.getElementById('custom-scroll');
    const ajaxUrl = newsContainer.dataset.url; // Get the AJAX URL from the data attribute
    let currentPage = 1;
    let isLoading = false;

    function fetchMoreNews() {
        if (isLoading) return; // Prevent multiple requests
        isLoading = true;

        fetch(`${ajaxUrl}?page=${currentPage}&isAjax=1`, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest' // Set the header for Yii2 detection
            }
        })
            .then(response => response.text()) // Get the response as text
            .then(htmlString => {
                // Append the new HTML content to the news container
                newsContainer.insertAdjacentHTML('beforeend', htmlString);
                isLoading = false;
                currentPage++;
            })
            .catch(error => {
                console.error('Error fetching news:', error);
                isLoading = false;
            });
    }

// Add scroll event listener to trigger infinite scrolling
    newsContainer.addEventListener('scroll', () => {
        const { scrollTop, scrollHeight, clientHeight } = newsContainer
        if (scrollTop + clientHeight+1 >= scrollHeight && !isLoading) {
            fetchMoreNews();
        }
    });
// Load initial set of articles
// fetchMoreNews();
}
latestNews();

// So'ngi yangiliklarni scrolli infinity qilish uchun js

$('body').delegate('.toggle__mobile__menu', 'click', function (e){
    // e.preventDefault();
    $(this).toggleClass('item-active');
})
$('body').delegate('.mobile__user__profile>ul>li', 'click', function (e){
    e.preventDefault();
    $('.user__items').toggleClass('user__items__click');
})
$('body').delegate('.logout-profile', 'click', function() {
    let url = $(this).data('url');
    $.post(url, { '_csrf-frontend': getCsrfToken() }, function() {
        window.location.reload();
    });
});

var getCsrfToken = function() {
    return $('meta[name="csrf-token"]').attr("content");
}